/**
 * Tiny localStorage wrapper that never throws (private-mode, quota, SSR-safe).
 * Falls back to an in-memory map. Used by the local persistence services.
 */
const memory = new Map<string, string>();

function ls(): Storage | null {
  try {
    return typeof localStorage !== 'undefined' ? localStorage : null;
  } catch {
    return null;
  }
}

export const storage = {
  get(key: string): string | null {
    const s = ls();
    if (s) {
      try {
        return s.getItem(key);
      } catch {
        /* fall through */
      }
    }
    return memory.has(key) ? memory.get(key)! : null;
  },
  set(key: string, value: string): void {
    memory.set(key, value);
    const s = ls();
    if (s) {
      try {
        s.setItem(key, value);
      } catch {
        /* ignore */
      }
    }
  },
  getJSON<T>(key: string, fallback: T): T {
    const raw = this.get(key);
    if (raw == null) return fallback;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return fallback;
    }
  },
  setJSON(key: string, value: unknown): void {
    this.set(key, JSON.stringify(value));
  },
};
